import ethereum from 'decentralized/ethereum.js';
import QueryDecryptor from "crypto/QueryDecryptor.js";
import {web3} from 'decentralized/web3.js';

export const decryptResults = async (results, guildId) => {
    const queryDecryptor = new QueryDecryptor(ethereum.crypto);
    if (guildId !== 0) {
        let guildKey = await ethereum.guilds.getGuildKey(guildId);
        let decryptedResults = [];
        for (let i in results) {
            decryptedResults.push(
                await queryDecryptor
                    .decryptQueryResult(results[i], guildKey.privateKey));
        }
        results = decryptedResults;
    } else {
        results = results.map(x => ({
            ... x,
            title: web3.utils.toAscii('0x' + x.encryptedName),
        }));
    }
    return results;
}
